export default __webpack_public_path__ + "static/media/service ui-whitebg.542f5bc6.png";